import React from 'react';
import _ from 'underscore';

import {DigestAnalysis} from 'analyses/Analyses';
import {ButtonStyle} from 'ui-library/buttons/Button';
import Modal from 'ui-library/modals/Modal';

interface DeleteDigestConfirmationModalProps {
  digest: DigestAnalysis;
  onRequestClose: () => void;
  onRequestSubmit: () => void;
}

export default function DeleteDigestConfirmationModal({
  digest,
  onRequestClose,
  onRequestSubmit,
}: DeleteDigestConfirmationModalProps): JSX.Element {
  return (
    <Modal
      buttons={[
        {text: 'Confirm', submit: true, style: ButtonStyle.PRIMARY, onClick: onRequestSubmit},
        {text: 'Cancel', cancel: true, style: ButtonStyle.TERTIARY_GRAY, onClick: onRequestClose},
      ]}
      onRequestClose={onRequestClose}
      title="Confirm Deleting Digest"
    >
      <div>
        <b>{_.escape(digest.get('name'))}</b> is currently open in a tab - are you sure you want to delete it
        and close its tab?
      </div>
    </Modal>
  );
}
